module.exports = __webpack_public_path__ + "img/folder_closet.533b711b.svg";